import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const PasswordField = ({ password, setPassword, error, clearError }) => {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handlePasswordChange = (e) => {
    const value = e.target.value;

    if (setPassword) {
      setPassword(value);
    }

    // Clear validation error when typing
    if (clearError) {
      clearError();
    }
  };

  return (
    <div className="mb-3 position-relative">
      <label htmlFor="password" className="form-label">
        {t("Password")}
      </label>
      <div className="input-group">
        <input
          type={showPassword ? "text" : "password"}
          className={`form-control ${error ? "is-invalid" : ""}`}
          id="password"
          placeholder={t("Enter_your_password")}
          value={password}
          onChange={handlePasswordChange}
        />

        <button
          type="button"
          className="btn"
          onClick={togglePasswordVisibility}
          style={{
            position: "absolute",
            right: "10px",
            top: "50%",
            transform: "translateY(-50%)",
            border: "none",
            background: "transparent",
          }}
        >
          <i
            className={`fa-solid ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
          />
        </button>

        {error && <div className="invalid-feedback">{error}</div>}
      </div>
    </div>
  );
};

export default PasswordField;
